import React, { memo, useMemo } from 'react'
import { CategoryListMobile } from './mobile'
import { CategoryListDesktop } from './desktop'
import { useRecoilValue } from 'recoil'
import { clientIsMobile } from 'state/common/atoms'
import { Box } from '@chakra-ui/react'

// 불필요한 리렌더링 방지를 위해 메모이제이션 적용
export const CategoryList = memo(() => {
  const isMobile = useRecoilValue(clientIsMobile)
  
  // 루트 경로 캐싱
  const localCacheKey = 'cached_route_time';
  const cacheTime = 30 * 60 * 1000; // 30분
  
  useMemo(() => {
    try {
      const now = Date.now();
      const lastVisitTime = localStorage.getItem(localCacheKey);
      
      // 캐싱 시간 업데이트
      if (!lastVisitTime || now - parseInt(lastVisitTime) > cacheTime) {
        localStorage.setItem(localCacheKey, now.toString());
      }
    } catch (error) {
      console.warn('로컬 캐시 업데이트 실패', error);
    }
  }, []);

  if (isMobile) return <CategoryListMobile />
  return <CategoryListDesktop />
})
